import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { updateUserSettings } from 'redux/modules/userSettings';
import { PageHeader } from 'components';
import { LoggedOutLayout, UserSettings } from 'containers';
import * as styles from './NewPartnerUserSetup.scss';
var NewPartnerUserSetup = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewPartnerUserSetup, _Component);

  var _super = _createSuper(NewPartnerUserSetup);

  function NewPartnerUserSetup() {
    _classCallCheck(this, NewPartnerUserSetup);

    return _super.apply(this, arguments);
  }

  _createClass(NewPartnerUserSetup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showNavBar: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Welcome!"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          flex: 1,
          maxWidth: 350
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "User Profile and Password Setup",
        style: {
          marginTop: 32
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 100%',
          maxWidth: 350
        }
      }, /*#__PURE__*/React.createElement(UserSettings, {
        isModal: true,
        noModalTopBar: true,
        includePageHeader: false,
        redirectOnSubmitUrl: "/org/".concat(this.props.theme.org, "/schedule"),
        requirePassword: true
      }))));
    }
  }]);

  return NewPartnerUserSetup;
}(Component)) || _class);
export { NewPartnerUserSetup as default };